module.exports = __webpack_public_path__ + "img/windmill.b7588d58.png";